import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Typography from '@material-ui/core/Typography'
import AddOutlinedIcon from 'components/material-symbol/icons/Add'
import { TonalButton } from 'components/empty-page-state'
import Dialog from 'components/dialog'
import { useDialogTitleStyles } from 'components/dialog/use-dialog-title-styles'
import OneTimeSlotForm from './one-time-slot-form'

const labelFor = initialType => {
  if (initialType === 'block') return 'Add Blocked Time'
  if (initialType === 'open') return 'Add Open Time'
  return 'Add One-Time Slot'
}

const titleFor = initialType => {
  if (initialType === 'block') return 'Add Blocked Time'
  if (initialType === 'open') return 'Add Open Time'
  return 'Add One-Time Slot'
}

const OneTimeSlotDialog = ({
  facilities,
  onSuccess,
  triggerProps,
  initialType,
  compact,
  tonal,
  triggerless,
  isOpen,
  onClose,
  defaultFacilityId,
  defaultDate,
  defaultStartTime,
  existingOverrides,
}) => {
  const titleClasses = useDialogTitleStyles()
  const label = labelFor(initialType)

  const trigger = triggerless ? (
    undefined
  ) : compact ? (
    <IconButton color="primary" aria-label={label} title={label}>
      <AddOutlinedIcon />
    </IconButton>
  ) : tonal ? (
    <TonalButton startIcon={<AddOutlinedIcon />}>{label}</TonalButton>
  ) : (
    <Button
      variant="contained"
      color="primary"
      startIcon={<AddOutlinedIcon />}
      style={{ whiteSpace: 'nowrap' }}
      {...triggerProps}
    >
      {label}
    </Button>
  )

  return (
    <Dialog
      trigger={trigger}
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      showCloseButton
      classes={{ paper: titleClasses.dialogPaper }}
    >
      {({ closeDialog }) => (
        <>
          <DialogTitle
            disableTypography
            classes={{ root: titleClasses.titleRoot }}
          >
            <Typography component="h2" className={titleClasses.title}>
              {titleFor(initialType)}
            </Typography>
          </DialogTitle>
          <DialogContent classes={{ root: titleClasses.content }}>
            <Box pb={1}>
              <OneTimeSlotForm
                facilities={facilities}
                initialType={initialType}
                defaultFacilityId={defaultFacilityId}
                defaultDate={defaultDate}
                defaultStartTime={defaultStartTime}
                existingOverrides={
                  initialType === 'open' ? existingOverrides : undefined
                }
                onSuccess={() => {
                  onSuccess && onSuccess()
                  closeDialog()
                }}
                onCancel={closeDialog}
              />
            </Box>
          </DialogContent>
        </>
      )}
    </Dialog>
  )
}

export default OneTimeSlotDialog
